import { useDispatch, useSelector } from 'react-redux';
import './CategoryBrowse.css';
import React, { useEffect, useState, useRef } from 'react';
import Reference from '../CreateDatum/AddReferenceModal/Reference/Reference';
import { getCategoryFeed } from '../../../actions/ItemAction';
import Category from './Category/Category';
import { TbCategory2, TbFaceIdError } from 'react-icons/tb';
import { MdFilterAltOff } from 'react-icons/md';
import InfiniteScrollLoader from '../ItemFeed/InfiniteScrollLoader';

const CategoryBrowse = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.authReducer.authData);
    const { loading: authDataLoading } = useSelector((state) => state.authReducer);
    const { categoryFeed, navPath, loading: categoryFeedLoading, hasMore, totalItems } = useSelector((state) => state.categoryFeedReducer);
    const [page, setPage] = useState(0);
    const currentCategoryId = navPath && navPath.length > 0 
    ? navPath[navPath.length - 1].itemId 
    : null;

    const filtersObj = {
        sort: null,
    };
    const [filters, setFilters] = useState(filtersObj);

    useEffect(() => {
        if (!authDataLoading) {
            dispatch(getCategoryFeed(user._id, null, null, null, 0));
        }
    }, [authDataLoading]);
    const hasMoreRef = useRef(hasMore);
    const loadingRef = useRef(categoryFeedLoading);
    const pageRef = useRef(page);
    const filtersRef = useRef(filters);
    const isFetchingRef = useRef(false);

    const currentItemIdRef = useRef(null);
    const currentNavRef = useRef(null);

    useEffect(() => { hasMoreRef.current = hasMore; }, [hasMore]);
    useEffect(() => { loadingRef.current = categoryFeedLoading; }, [categoryFeedLoading]);
    useEffect(() => { pageRef.current = page; }, [page]);
    useEffect(() => { filtersRef.current = filters; }, [filters]);


    const handleChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
    };

    const handleChecked = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.checked });
    };

    const handleSubmitFilters = (e) => {
        e.preventDefault();
    };

    const handleNavClick = (itemId, index) => {
        currentItemIdRef.current = itemId;
        currentNavRef.current = index;
        console.log("Trggered")
        setPage(0)
        dispatch(getCategoryFeed(user._id, itemId, index, JSON.stringify(filters), 0));
        document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
    };
    const clearFilters = () => {
        setFilters(filtersObj);
        setPage(0)
        document.querySelectorAll('#itemFeed_filter_bar input[type="text"]').forEach(input => {
            input.value = '';
        });
        document.querySelectorAll('#itemFeed_filter_bar input[type="checkbox"]').forEach(input => {
            input.checked = false;
        });
        dispatch(getCategoryFeed(user._id, null, null, null, 0));
    };

    useEffect(() => {
        const appContainer = document.querySelector('.App');
    
        const handleScroll = () => {
            const nearBottom =
                appContainer.scrollHeight - appContainer.scrollTop - appContainer.clientHeight < 200;
            
            if (nearBottom && hasMoreRef.current && !isFetchingRef.current) {
                isFetchingRef.current = true
                const nextPage = pageRef.current + 1;
                setPage(nextPage);
                dispatch(getCategoryFeed(
                    user._id, 
                    currentItemIdRef.current,
                    currentNavRef.current,
                    JSON.stringify(filtersRef.current), 
                    nextPage
                )).finally(() => {
                    isFetchingRef.current = false;
                });
            }
        };
    
        appContainer.addEventListener('scroll', handleScroll);
        return () => appContainer.removeEventListener('scroll', handleScroll);
    }, []);

    // Determine if it's the main category view
    const isMainCategory = !navPath || navPath.length === 0;

    function NoItems() {
        var noItemsText = "";
        switch(user.userType) {
            case 0:
                if (user.follow.length === 0) {
                    noItemsText = "You aren't following any Groups yet!  Click on Find Groups above, follow one or more whose Values align with yours, and you'll begin to see the Items that they think are most important for you to see.";    
                 } else {
                     noItemsText = "Not all Groups utilize Categories, so don't worry - this may be expected!";
                 }
                 break;
            case 1:
                noItemsText = "Categories are a useful way for Authors to organize their Items in a way that makes it easier for users to search and find them.  Be sure you're using Categories that your Group(s) use(s) for best results.";
                break;
            case 2:
                noItemsText = "Once you begin stamping Data with Category relations, the Items that they reference will appear here."
                break;
        }
        return (
            <div className='General-nr-container'>
                <span className='General-nr-top'>You don't have any Items to in your Category Browse.</span>
                <TbFaceIdError size='30'/>
                <div className='General-nr-hint'>{noItemsText}</div>
            
            </div>
        )
    }


    return (
        <>
            {/* <div className="General-filter-bar General-hidden " id="categoryBrowse_filter_bar">
                <form action="" className="FlexColumn General-filter-form" onSubmit={handleSubmitFilters}>
                    <span className="FlexRow General-filter-form">
                        <span className="General-filter-key">Username:</span>
                        <input
                            type="text"
                            placeholder="Filter by user name..."
                            name="username"
                            className="General-input"
                            onChange={handleChange}
                        />
                    </span>
                    <span className="FlexRow General-filter-form">
                        <span className="General-filter-key">Keyword:</span>
                        <input
                            type="text"
                            placeholder="Filter by keyword..."
                            name="keyword"
                            className="General-input"
                            onChange={handleChange}
                        />
                    </span>
                    {user.userType !== 0 ? (
                        <div className="FlexColumn General-filter-form">
                            <span className="FlexRow General-filter-form">
                                <span className="General-filter-key">Include Subscribed:</span>
                                <input id="subscribed" name="subscribed" type="checkbox" onClick={handleChecked} />
                            </span>
                        </div>
                    ) : (
                        <div className="FlexColumn General-filter-form">
                            <span className="FlexRow General-filter-form">
                                <span className="General-filter-key">Include Followed:</span>
                                <input id="followed" name="followed" type="checkbox" onClick={handleChecked} />
                            </span>
                        </div>
                    )}
                    <div className='FlexRow General-filter-form items-center flex justify-center'>
                        <button className='button signupButton' type='submit'>
                            Apply Filters
                        </button>
                        <button 
                            className='button signupButton' 
                            type='button' 
                            onClick={clearFilters}
                            title='Clear all filters'
                        >
                            <MdFilterAltOff />
                        </button>
                    </div>
                </form>
            </div> */}

            <div className="catNavPath FlexRow" onClick={()=> console.log("cat clicked")}>
                <div className="cb-nav FlexRow" onClick={(e) => {
                    e.stopPropagation();
                    console.log("Tb clicked")
                     handleNavClick(null, null)}}>
                    <TbCategory2 />
                </div>
                {navPath && navPath.map((n, id) => (
                    <React.Fragment key={id}>
                        <div>/</div>
                        <div 
                            className="cb-nav FlexRow" 
                            onClick={(e) => {
                                e.stopPropagation();
                                console.log("Nre itm cli")
                                currentItemIdRef.current = n.itemId;
                                currentNavRef.current = id;
                                setPage(0);
                                dispatch(getCategoryFeed(user._id, n.itemId, id, JSON.stringify(filters), 0));
                                document.getElementById('top')?.scrollIntoView({ behavior: 'smooth' });
                            }}
                        >
                            {n.itemName}
                        </div>
                    </React.Fragment>
                ))}
            </div>
            <div className='feed-result-count'>
                {categoryFeedLoading ?
                "Loading": 
                `Search returned ${totalItems} ${totalItems === 1 ? 'Result' : 'Results'}`}.
            </div>
            <div className="ItemFeed">
                {categoryFeed && categoryFeed.length > 0
                    ? categoryFeed.map((item, _id) => {
                          // Show only categories in the main section
                          if (isMainCategory) {
                              return item.itemType === 4 && (
                              <Category 
                                category={item} 
                                key={_id} 
                                onNavigate={(itemId, nav) => {
                                    currentItemIdRef.current = itemId;
                                    currentNavRef.current = nav;
                                    setPage(0)
                                    dispatch(getCategoryFeed(user._id, itemId, nav, JSON.stringify(filters), 0));
                                }} 
                              />
                            )
                          }

                          // Show both categories and references in subcategories
                          return item.itemType === 4 ? (
                              <Category category={item} key={_id} onNavigate={(itemId, nav) => {
                                currentItemIdRef.current = itemId;
                                currentNavRef.current = nav;
                                setPage(0);
                                dispatch(getCategoryFeed(user._id, itemId, nav, JSON.stringify(filters), 0));
                              }} />
                          ) : (
                              <Reference reference={item} key={_id} location="category" value={currentCategoryId} />
                          );
                      })
                    : <NoItems/>
                }
            </div>
            {categoryFeed && categoryFeed.length > 0 && (
                <InfiniteScrollLoader hasMore={hasMore} />
            )}
        </>
    );
};

export default CategoryBrowse;
